import { FaArrowLeft } from "react-icons/fa"; 
import './ScreenTitle.css';

function ScreenTitle({  onBack, getHeaderTitle }: {  onBack: () => void; getHeaderTitle: () => string }) {
  return (
 <header className="expert-nav-surface">
        <div className="nav-container">
          <div className="nav-slot -left">
            <button className="nav-action-trigger" style={{border:'none', background:'transparent'}}onClick={onBack} aria-label="Go Back">
              <div className="icon-orbit">
                <FaArrowLeft />
              </div>
            </button>
          </div>
          <div className="nav-slot -center">
            <div className="brand-stack">
              <h1 className="brand-main-title">{getHeaderTitle()}</h1>
            </div>
          </div>
          <div className="nav-slot -right">
              <div className="nav-spacer" />
          </div>
        </div>
      </header>
  )
}

export default ScreenTitle;